/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'

import ButtonBase from '../../lib/components/ButtonBase'

const Button = {
  Container: styled.div`
    display: flex;
  `,
  Today: styled(ButtonBase)`
    width: 70px;
    height: 30px;
    margin-right: 16px;

    &::before {
      content: 'Today';
    }
  `,
  LastMonth: styled(ButtonBase)`
    width: 30px;
    height: 30px;
    margin-right: 8px;

    &::before {
      content: '<';
    }
  `,
  NextMonth: styled(ButtonBase)`
    width: 30px;
    height: 30px;
    margin-left: 8px;

    &::before {
      content: '>';
    }
  `,
  ThisMonth: styled(ButtonBase)`
    width: 134px;
    height: 30px;

    cursor: default;
  `,
}

/**
 * @param {object} props
 * @param {string} props.currentMonth
 * @param {boolean} [props.viewMode]
 * @param {() => void} props.clickToday
 * @param {() => void} props.clickLastMonth
 * @param {() => void} props.clickNextMonth
 * @param {boolean} props.disableLastMonth
 */
function MonthSelector(props) {
  const {
    currentMonth,
    viewMode,
    clickToday,
    clickLastMonth,
    clickNextMonth,
    disableToday,
    disableLastMonth,
  } = props

  if (viewMode) {
    return (
      <Button.Container>
        <Button.ThisMonth>{currentMonth}</Button.ThisMonth>
      </Button.Container>
    )
  }

  return (
    <Button.Container>
      <Button.Today inactive={ disableToday } onClick={ clickToday } />
      <Button.LastMonth inactive={ disableLastMonth } onClick={ clickLastMonth } />
      <Button.ThisMonth>{currentMonth}</Button.ThisMonth>
      <Button.NextMonth onClick={ clickNextMonth } />
    </Button.Container>
  )
}

export default MonthSelector



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/MonthSelector.jsx